import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';
import { JwtService } from './jwt.service';
import { LocalStorageService } from './local-storage.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  loginStatus: BehaviorSubject<boolean>;

  constructor(
    private apiService: ApiService,
    private jwtService: JwtService,
    private localStorageService: LocalStorageService,
    private router: Router
  ) {
    // The session itself lives in an HttpOnly cookie (invisible to JS) — the cached
    // profile object is the only client-side signal of "was logged in" at bootstrap.
    const userExists = !!this.localStorageService.getUser();
    this.loginStatus = new BehaviorSubject<boolean>(userExists);
  }

  setLoginStatus(status: boolean) {
    this.loginStatus.next(status);
  }

  getLoginStatus() {
    return this.loginStatus.asObservable();
  }

  // Single source of truth for logging out: invalidates the session cookie server-side,
  // then clears cached profile data regardless of whether the API call succeeds.
  logout(navigationExtras?: NavigationExtras): void {
    this.apiService.post(environment.routes.LOGOUT_API).subscribe({
      complete: () => this.finishLogout(navigationExtras),
      error: () => this.finishLogout(navigationExtras)
    });
  }

  private finishLogout(navigationExtras?: NavigationExtras): void {
    this.setLoginStatus(false);
    this.jwtService.destroyToken(); // also clears the cached lmf_user object
    this.router.navigate(['/login'], navigationExtras);
  }
}
